import { Add } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { PageHeader } from '../../../components/PageHeader';
import { PageContent, PageLayout } from '../../../layout';
import { InvoiceTable } from './components/InvoiceTable';

export const Invoices = () => {
  const { t } = useTranslation();
  return (
    <PageLayout>
      <PageHeader
        title={t('invoices.overview')}
        backRouteTo={null}
        action={
          <Button size={'large'} component={Link} to={'/upload'} startIcon={<Add />} variant={'contained'}>
            {t('addInvoice')}
          </Button>
        }
      />
      <PageContent sx={{ alignItems: 'flex-start', justifyContent: 'flex-start' }}>
        <InvoiceTable checkboxSelection={true} />
      </PageContent>
    </PageLayout>
  );
};
